import { takeLatest } from 'redux-saga/effects';
import { crudSlice } from 'saga-slice-helpers';
import Swal from '#/swal';
import { sagaApi } from '#/apis';

const sagaSliceModule = crudSlice({
    name: 'eval-questions',
    sagaApi,
    sagas: A => ({
        [A.readAll]: {
            *saga ({ payload: titleId }) {

                yield sagaApi.get(
                    `/titles/${titleId}/eval-questions`,
                    A.readAllSuccess,
                    A.readAllFail
                );
            },
            taker: takeLatest
        },

        [A.delete]: {
            *saga ({ payload: titleId }) {

                const { value } = yield Swal.fire.warning();

                if (value) {
                    yield sagaApi.delete(`/eval-questions/${titleId}`, null, A.deleteSuccess, A.deleteFail);
                }

            }
        }
    })
});

export const { actions } = sagaSliceModule;
export default sagaSliceModule;
